/**
 * Initializes collection-list sliders that depend on the global Swiper build.
 */
(() => {
  const roots = () => document.querySelectorAll('[data-store-collection-list]');

  const syncNav = (root, swiper) => {
    const prev = root.querySelector('[data-store-cl-prev]');
    const next = root.querySelector('[data-store-cl-next]');
    if (!(prev instanceof HTMLElement) || !(next instanceof HTMLElement)) return;

    const atStart = swiper.isBeginning;
    const atEnd = swiper.isEnd;
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  };

  const initRoot = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.storeClReady === 'true') return;

    const el = root.querySelector('[data-store-cl-swiper]');
    if (!(el instanceof HTMLElement) || el.swiper) return;
    if (typeof window.Swiper !== 'function') return;

    const columns = Number(root.dataset.columns || '2');
    const prev = root.querySelector('[data-store-cl-prev]');
    const next = root.querySelector('[data-store-cl-next]');

    const swiper = new window.Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 8,
      watchOverflow: true,
      speed: 450,
      breakpoints: {
        750: {
          slidesPerView: Math.min(2, columns),
          spaceBetween: 8,
        },
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      a11y: {
        prevSlideMessage: root.dataset.labelPrev || 'Previous',
        nextSlideMessage: root.dataset.labelNext || 'Next',
      },
      on: {
        init() {
          syncNav(root, this);
        },
        slideChange() {
          syncNav(root, this);
        },
        resize() {
          syncNav(root, this);
        },
      },
    });

    root.dataset.storeClReady = 'true';
    return swiper;
  };

  const initAll = () => {
    roots().forEach(initRoot);
  };

  const waitForSwiper = (attempt = 0) => {
    if (typeof window.Swiper === 'function') {
      initAll();
      return;
    }
    if (attempt > 40) return;
    window.setTimeout(() => waitForSwiper(attempt + 1), 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForSwiper());
  } else {
    waitForSwiper();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!(section instanceof HTMLElement)) return;
    const root = section.querySelector('[data-store-collection-list]');
    if (root) {
      root.dataset.storeClReady = 'false';
      waitForSwiper();
    }
  });
})();
